import { render, staticRenderFns } from "./Ticketing.vue?vue&type=template&id=43da4416&scoped=true"
import script from "./Ticketing.vue?vue&type=script&lang=js"
export * from "./Ticketing.vue?vue&type=script&lang=js"
import style0 from "./Ticketing.vue?vue&type=style&index=0&id=43da4416&lang=css"
import style1 from "./Ticketing.vue?vue&type=style&index=1&id=43da4416&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43da4416",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43da4416')) {
      api.createRecord('43da4416', component.options)
    } else {
      api.reload('43da4416', component.options)
    }
    module.hot.accept("./Ticketing.vue?vue&type=template&id=43da4416&scoped=true", function () {
      api.rerender('43da4416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/Ticketing.vue"
export default component.exports